import {
  DESKTOP_WIDTH,
  FORM_MOBILE_ACTIONS_MAX_WIDTH,
  MOBILE_SCREEN_MAX_WIDTH,
} from '../constants/screen'

function getScreenWidth() {
  return window.innerWidth || DESKTOP_WIDTH
}

export function getScreenState() {
  const width = getScreenWidth()

  const isMobileScreenSize = width <= MOBILE_SCREEN_MAX_WIDTH

  return {
    isMobileScreenSize,
    width,
  }
}

export function isFormMobileActions({
  maxWidth = FORM_MOBILE_ACTIONS_MAX_WIDTH,
  screenWidth,
}) {
  return screenWidth <= maxWidth
}
